import React, {Fragment, useEffect} from "react";
import {useAccessToken, useAccessTokenProvider, useCurrentUserProvider, useRefreshAccessToken} from "~/auth/hooks";
import {getAccessTokenExpiresIn} from "~/auth/functions";


const RefreshSession = (props) => {
    const accessToken = useAccessToken();
    const [refresh] = useRefreshAccessToken();
    const events = ["mousemove", "click", "touchmove", "touchstart"];

    useEffect(() => {
        if (accessToken && getAccessTokenExpiresIn(accessToken) > 0) {
            const handler = () => refresh();
            events.forEach(event => document.addEventListener(event, handler));
            return () => {
                events.forEach(event => document.removeEventListener(event, handler));
            }
        }
    }, [accessToken, refresh]);

    // refresh when open application
    useEffect(() => {
        refresh();
    }, [refresh])

    return null;
}

export const AuthProvider = ({children}) => {
    const AccessTokenProvider = useAccessTokenProvider();
    const CurrentUserProvider = useCurrentUserProvider();
    return (
        <AccessTokenProvider>
            <RefreshSession/>
            <CurrentUserProvider>
                {children}
            </CurrentUserProvider>
        </AccessTokenProvider>
    )
}